
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({
  props: {
    classComponent: String,
    imageFile: String,
  },
})
export default class SectionArea extends Vue {}
